'use client';
import { ListItem } from './list-item.js';
import { ListOrdered, ListUnordered } from './lists.js';

const ListComponent = {
    Item: ListItem,
    Ordered: ListOrdered,
    Unordered: ListUnordered,
};
ListComponent.Item.displayName = 'List.Item';
ListComponent.Ordered.displayName = 'List.Ordered';
ListComponent.Unordered.displayName = 'List.Unordered';

export { ListComponent as List, ListItem, ListOrdered, ListUnordered };
